// extracted by mini-css-extract-plugin
module.exports = {"image":"dokka-module--image--2zTw8","link":"dokka-module--link--1tala","content":"dokka-module--content--1mi_I"};